/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Guardrails_Desc10Inputs */

const en_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost limits, human-in-the-loop checkpoints, input/output validation, and failure handling so autonomy never means runaway spend.`)
};

const ar_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدود التكلفة، نقاط تحقق بشرية، تحقق من المدخلات والمخرجات، ومعالجة الأخطاء حتى لا تعني الاستقلالية نفقات خارجة عن السيطرة.`)
};

const bn_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কস্ট লিমিট, হিউম্যান-ইন-দ্য-লুপ চেকপয়েন্ট, ইনপুট/আউটপুট ভ্যালিডেশন ও ফেইলিওর হ্যান্ডলিং, অটোনমি মানেই নিয়ন্ত্রণহীন খরচ নয়।`)
};

const de_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostengrenzen, Human-in-the-Loop-Kontrollpunkte, Eingabe-/Ausgabevalidierung und Fehlerbehandlung, sodass Autonomie niemals unkontrollierte Ausgaben bedeutet.`)
};

const es_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de costos, puntos de control con intervención humana, validación de entrada/salida y manejo de fallas para que la autonomía nunca signifique un gasto descontrolado.`)
};

const fr_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de coûts, points de contrôle humains, validation des entrées/sorties et gestion des pannes pour que l'autonomie ne signifie jamais des dépenses incontrôlables.`)
};

const pt_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de custo, pontos de verificação humanos, validação de entrada/saída e tratamento de falhas para que autonomia nunca signifique gastos excessivos.`)
};

const zh_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本限制、人机交互检查点、输入/输出验证和故障处理，因此自主永远不会意味着失控的支出。`)
};

const tr_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet sınırları, döngüdeki insan kontrol noktaları, giriş/çıkış doğrulama ve arıza yönetimi sayesinde özerklik hiçbir zaman kontrolden çıkmış harcama anlamına gelmez.`)
};

const ru_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничения затрат, контрольные точки с участием человека, проверка ввода-вывода и обработка сбоев, поэтому автономия никогда не означает безудержных расходов.`)
};

const pl_svc_ai_agent_development_guardrails_desc10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limity kosztów, punkty kontrolne w pętli, weryfikacja danych wejściowych/wyjściowych i obsługa błędów, więc autonomia nigdy nie oznacza niekontrolowanych wydatków.`)
};

/**
* | output |
* | --- |
* | "Cost limits, human-in-the-loop checkpoints, input/output validation, and failure handling so autonomy never means runaway spend." |
*
* @param {Svc_Ai_Agent_Development_Guardrails_Desc10Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_guardrails_desc10 = /** @type {((inputs?: Svc_Ai_Agent_Development_Guardrails_Desc10Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Guardrails_Desc10Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "de") return de_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "es") return es_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_guardrails_desc10(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_guardrails_desc10(inputs)
	return en_svc_ai_agent_development_guardrails_desc10(inputs)
});
export { svc_ai_agent_development_guardrails_desc10 as "svc_ai-agent-development_GUARDRAILS_desc" }